<template>
    <div class="content-wrapper">
        <section class="content-header">
            <h1>
                {{ $t('shortDomains.shortDomain') }}
                <template v-if="isLoaded && shortDomain.id"> #{{ shortDomain.id }} </template>

                <div
                    v-if="isLoaded"
                    class="pull-right"
                >
                    <router-link
                        :to="{ name: 'short-domains.list' }"
                        class="btn btn-sm btn-default"
                    >
                        <span class="sr-only">{{ $t('shortDomains.shortDomainsList') }}</span>
                        <span class="hidden-xs">{{ $t('shortDomains.shortDomainsList') }}</span>
                        <span class="visible-xs">
                            <i class="fa fa-list-ul"></i>
                        </span>
                    </router-link>

                    <router-link
                        v-if="isLoaded"
                        :to="{
                        name: 'short-domains.new',
                    }"
                        class="btn btn-sm btn-primary"
                    >
                        <span class="sr-only">{{ $t('addNew') }}</span>
                        <span class="hidden-xs">{{ $t('addNew') }}</span>
                        <span class="visible-xs">
                        <i class="fa fa-edit"></i>
                    </span>
                    </router-link>

                    <router-link
                        v-if="isLoaded"
                        :to="{
                            name: 'short-domains.edit',
                            params: { id: shortDomain.id },
                        }"
                        class="btn btn-sm btn-primary"
                    >
                        <span class="sr-only">{{ $t('edit') }}</span>
                        <span class="hidden-xs">{{ $t('edit') }}</span>
                        <span class="visible-xs">
                            <i class="fa fa-edit"></i>
                        </span>
                    </router-link>
                </div>
            </h1>
        </section>

        <section class="content">
            <Alerts />

            <div class="row">
                <div class="col-xs-12">
                    <div class="box box-primary">
                        <div
                            v-if="!isLoaded"
                            class="box-body"
                        >
                            <img
                                class="table-row-preloader"
                                rel="preload"
                                src="/img/table-row-preloader.gif"
                            />
                        </div>

                        <div
                            v-show="isLoaded"
                            class="box-header with-border"
                        >
                            <h3 class="box-title">Info</h3>

                            <div class="box-tools pull-right">
                                <button
                                    class="btn btn-box-tool"
                                    :title="$t('collapse')"
                                    type="button"
                                    @click="isCollapse = !isCollapse"
                                >
                                    <i
                                        class="fa"
                                        :class="{
                                            'fa-plus': !isCollapse,
                                            'fa-minus': isCollapse,
                                        }"
                                    />
                                </button>
                            </div>
                        </div>

                        <vue-slide-up-down
                            v-show="isLoaded"
                            :active="isCollapse"
                        >
                            <ShortDomainsShow
                                @loaded="isLoaded = $event"
                                @shortDomain="shortDomain = $event"
                            />
                        </vue-slide-up-down>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import ShortDomainsShow from '@/components/short-domains/ShortDomainsShow';

export default {
    components: {
        ShortDomainsShow,
    },

    data() {
        return {
            isCollapse: true,
            isLoaded: false,
            shortDomain: {},
        };
    },
};
</script>
